export default __webpack_public_path__ + "static/media/Pill 2.1753042f.png";